import script from "./SliderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderCard.vue?vue&type=script&setup=true&lang=js"

import "./SliderCard.vue?vue&type=style&index=0&id=5fe63f1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe63f1a"]])

export default __exports__